<template>
  <div class="container">
    <div class="col-md-12 mt-3">
      <h2>{{ labels.title }}</h2>
    </div>
    <div class="row mt-4">
      <div class="col-md-6 d-flex justify-content-end align-items-center">
        <h5 class="mb-0 mr-2">{{ labels.fecha }}</h5>
      </div>
      <div class="col-md-2 pl-0">
        <!-- <input type="month" v-model="fecha" class="form-control" style="width: 180px;"/> -->
        <select v-model="fecha" class="form-control">
          <option value="">{{ labels.seleccion }}</option>
          <option v-for="item in lstFechaCierre" :key="item.id" :value="item.fecha_cierre"> {{ item.fecha_cierre }} </option>
        </select>
      </div>
    </div>
    <div class="col-md-12 mt-4">
        <b-button type="button" id="create-btn" @click="consulReporTipoActivo">{{ labels.consultar }}</b-button>
    </div>
    <div v-if="lstReporTipActivo.length" class="col-md-12 mt-3">
        <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genReporPorTipActivo()">
                <md-icon>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                </md-icon>
            </md-button>
        </div>
        <b-table
            :items="lstReporTipActivo"
            :fields="fields"
            hover
            bordered
            responsive
            sticky-header="500px"
            small
            class="tblEstandar"
            head-variant="custom-blue"
            :per-page="perPage"
            :current-page="currentPage"
        >
            <!-- Formato de todas las celdas numéricas -->
            <template #cell(total_valor_canon)="data">
                <div class="text-right">{{ formatNumber(data.item.total_valor_canon) }}</div>
            </template>
            <template #cell(pasivo_inicial)="data">
                <div class="text-right">{{ formatNumber(data.item.pasivo_inicial) }}</div>
            </template>
            <template #cell(total_cambio_pasivo)="data">
                <div class="text-right">{{ formatNumber(data.item.total_cambio_pasivo) }}</div>
            </template>
            <template #cell(total_pago_capital)="data">
                <div class="text-right">{{ formatNumber(data.item.total_pago_capital) }}</div>
            </template>
            <template #cell(total_intereses)="data">
                <div class="text-right">{{ formatNumber(data.item.total_intereses) }}</div>
            </template>
            <template #cell(pasivo_final)="data">
                <div class="text-right">{{ formatNumber(data.item.pasivo_final) }}</div>
            </template>
            <template #cell(activo_derecho_uso_bruto)="data">
                <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso_bruto) }}</div>
            </template>
            <template #cell(total_gasto_amortizacion)="data">
                <div class="text-right">{{ formatNumber(data.item.total_gasto_amortizacion) }}</div>
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="lstReporTipActivo.length"
            :per-page="perPage"
            align="center"
            size="md"
            class="mt-3"
        ></b-pagination>
        <div class="d-flex justify-content-end align-items-center mt-2">
            <label class="mr-2 mb-0">Filas por página:</label>
            <b-form-select
            v-model="perPage"
            :options="[5, 10, 20, 50]"
            size="sm"
            style="width: 80px;"
            ></b-form-select>
        </div>
    </div>
  </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre';
import Reportes from "../../services/Reportes";
import * as XLSX from "exceljs";

export default {
  name: "ReportePorTipoActivo",
  data: () => ({
    fecha: "",
    lstReporTipActivo: [],
    lstFechaCierre: [],
    btnGenExcel: false,
    perPage: 10,
    currentPage: 1,
    fields: [
        { key: 'descripcion', label: 'Tipo activo', sortable: true },
        { key: 'cantidad', label: 'Cantidad', sortable: false },
        { key: 'total_valor_canon', label: 'Total valor canon', sortable: false },
        { key: 'pasivo_inicial', label: 'Pasivo inicial', sortable: false },
        { key: 'total_cambio_pasivo', label: 'Total cambio pasivo', sortable: false },
        { key: 'total_pago_capital', label: 'Total pago capital', sortable: false },
        { key: 'total_intereses', label: 'Total intereses', sortable: false },
        { key: 'pasivo_final', label: 'Pasivo final', sortable: false },
        { key: 'activo_derecho_uso_bruto', label: 'Activo derecho uso bruto', sortable: false },
        { key: 'total_gasto_amortizacion', label: 'Total gasto amortización', sortable: false },
    ]
  }),
  computed: {
    labels() {
      if(this.$store.state._language == "es-ES"){
        return {
          title: "Reporte por tipo activo",
          fecha: "Fecha:",
          consultar: "Consultar",
          seleccion: "Seleccione..."
        };
      
      }else{

        return {
          title: "Report by asset type",
          fecha: "Date:",
          consultar: "Consult",
          seleccion: "Select..."
        };
      }
    }
  },
  methods: {
    formatNumber(value) {
      // Formatea con punto de miles y coma decimal
      return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
    },

    // 🔹 Consultar el reporte
    async consulReporTipoActivo() {
      if (!this.fecha) {
        this.$toast.error("Diligenciar la fecha.");
        return;
      }

      try {
        const res = await Reportes.generaReportePorTipoActivo(this.fecha);
        this.lstReporTipActivo = res.data.lstReporTipoAct || [];
        this.currentPage = 1;
        this.btnGenExcel = this.lstReporTipActivo.length > 0;

        if (!this.lstReporTipActivo.length) {
          this.$toast.error("No hay datos para la fecha seleccionada.");
        }
      } catch (err) {
        console.error(err);
      }
    },

    async genReporPorTipActivo(){

        const {Workbook} = XLSX
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet("Reporte tipo activo "+this.fecha)

        const titulo = ["Reporte tipo activo "+this.fecha]
        worksheet.addRow(titulo)
        worksheet.mergeCells('A1:J1')
        worksheet.getCell('A1').font = { bold : true, size : 12};
        worksheet.getCell('A1').alignment = { horizontal : 'center'};

        const tituloCelda = [
            'Tipo activo',
            'Cantidad',
            'Total valor canon',
            'Pasivo inicial',
            'Total cambio pasivo',
            'Total pago capital',
            'Total intereses',
            'Pasivo final',
            'Activo derecho uso bruto',
            'Total gasto amortización'
        ]

        worksheet.addRow(tituloCelda)
        for	(let fila = 1;fila<=2;fila++) {
            worksheet.getRow(fila).font = {
                name: "Arial Black",
                family: 2,
                size: 11,
                bold: true
            }
        }

        this.lstReporTipActivo.map((e) => {
            worksheet.addRow([
                e.descripcion,
                e.cantidad,
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.total_valor_canon),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.pasivo_inicial),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.total_cambio_pasivo),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.total_pago_capital),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.total_intereses),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.pasivo_final),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.activo_derecho_uso_bruto),
                Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.total_gasto_amortizacion)
            ])
        })

        //Poner borde
        const border = {
            top : {style : 'thin'},
            left : {style : 'thin'},
            bottom : {style : 'thin'},
            right : {style : 'thin'},
        }

        for( let row = 1; row <= worksheet.rowCount; row++){
            for( let col = 1; col <= worksheet.columnCount; col++){
                worksheet.getCell(row, col).border = border;
            }
        }
        //------

        const file = await workbook.xlsx.writeBuffer()
        const downloadLink = document.createElement("a")
        downloadLink.download = "Reporte tipo activo.xlsx"
        downloadLink.href = window.URL.createObjectURL(
            new Blob([file], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
        )

        downloadLink.style.display = "none";

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
    }
  },
  mounted(){
    ContratoCierre.getListadoFechas()
    .then((res) => {
      // console.log(res.data.lstFechaCierre);
      this.lstFechaCierre = res.data.lstFechaCierre
    })
    .catch((err) => console.log(err))
  },
  watch:{
    fecha(val){
      if(val == ""){
        this.lstReporTipActivo = []
      }
    }
  }
};
</script>

<style src="../main.css">
</style>
